export default function getIncomingShipments(storeId, shipments) {
  if (storeId === undefined) return shipments
  return shipments.filter(shipment => {
    return shipment.destination.id === storeId
  })
}
